import React from 'react';
import Layout from '../../components/layout/layout';
import { supabase } from '../../lib/supabase';
import { useNavigate } from 'react-router-dom';

export default function TimelineCampagnesPage() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const checkAdmin = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        navigate('/');
        return;
      }

      const { data: userData } = await supabase
        .from('users')
        .select('role')
        .eq('id', user.id)
        .single();

      if (userData?.role !== 'admin') {
        navigate('/');
      }
    };

    checkAdmin();
  }, [navigate]);

  return (
    <Layout>
      <div className="container-custom py-12">
        <h1 className="text-4xl font-bold mb-8">Timeline Campagnes</h1>
        {/* Add campaign timeline content here */}
      </div>
    </Layout>
  );
}